module.exports = __webpack_public_path__ + "img/broadcast-work-icon12.e9d558b8.png";